import React, { useEffect, useState, useRef, Suspense, lazy } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { AppRoutes, AppRoutesAdmin } from './AppRoutes';
// import { AppRoutesAdmin } from './AppRoutesAdmin';
import Favicon from 'src/components/Favicon';

import { msg } from "src/utils/functions/core"
// import LayoutAdmin from './components/LayoutAdmin';
import { querySelectValidation } from "src/utils/functions/queryFetch"
// import {} from "src/components/index";
// import Spinner from "src/components/addOn/spinner";
// import { Log } from 'oidc-client';
import { content, _logout } from "src/utils/functions/core"
import { socket } from 'src/utils/socket';
import MultiLogin from 'src/webWidgets/core/MultiLogin';
// const App = () => {
//   return  <div></div>
// }

// import Layout from './components/Layout';
const Layout = lazy(() => import('./components/Layout'))
const LayoutAdmin = lazy(() => import('./components/LayoutAdmin'))

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return <p>Loading failed! Please reload.</p>;
      }
      return this.props.children;
    }
  }

  const renderLoader = () => {
    return  <div>l</div>
  };

  const getLayout = async (token, pages) => {
    if (token) {
      return await AppRoutesAdmin(pages)
    } else {
      return await AppRoutes(pages)
    }
  }

  const App = (props) => {
    // console.log(socket?._callbacks)
    // const nodeRef = useRef(null);
    const location = useLocation()
    const navigate = useNavigate()

    const [ children, setChildren ] = useState()
    const [faviconUrl, setFaviconUrl] = useState(window.location.origin + "/media/img/favicon.png");
    // const [faviconUrl, setFaviconUrl] = useState(window.location.origin + "/media/img/favicon.png");

    const [state, setState] = useState({
      checknode: false,
      _routes: [],
      component: Layout
    })
    const { token, terminalMode, pages } = content()

    const f = () => {
      // add licence
      querySelectValidation({
        url: "/api/checknode"
      }).then(async (el) => {
        setFaviconUrl(false)
        if (typeof el === 'boolean' && el) {
          const _routes = await getLayout(token, pages)
          // console.log({
          //   terminalMode,
          //   pathname: window.location.pathname
          // })
          if (terminalMode && (window.location.pathname !== "/terminalMode")) {
            _logout(navigate)
          }
          if (_routes) {
            setState({
              checknode: el,
              _routes,
              component: token ? LayoutAdmin : Layout
            })
          }
          // nodeRef.current = _routes
        } else {
          setChildren( <div>No database</div>)
          msg("error", "Error please contact administrator - code - 007", 10)
        }
      })
    }

    useEffect(() => {
      if (token) {
        f()
      }
      return () => {
        setState(null)
        setChildren(null)
      }
    }, [token])
    // console.log(token)
    useEffect(() => {
      if (state?.checknode) {
        const s = async() => {
          const Component = state?.component
          // console.log(state?.component)
          setChildren(
            <Component key={JSON.stringify(state)}>
              <Routes>
                {state?._routes.map((route, index) => {
                  const { element, ...rest } = route;
                  const _element = { ...element, key: route?._id }
                  const _rest = { ...rest, key: route?._id }
                  // console.log({ element, _element, route, rest })
                  // console.log(_rest)
                  return <Route {..._rest} key={route?._id} element={_element} />
                })}
              </Routes>
            </Component>
          )
        }
        if (token) {
          s()
        }
      }
    }, [state?.checknode])

    useEffect(() => {
      const s = async() => {
        socket.on("clearLocalStorage", async(el) => {
          if (el?.type === "clearLocalStorage") {
            localStorage.clear()
            console.log({
              caches: await caches.keys()
            })
            msg("info", ("New app version, please wait ..."), 2)
            setTimeout(() => {
              window.location.reload()
            }, 2000)
          }
        })
      }
      if (token) {
        s()
      }
    }, [])

    // console.log(faviconUrl)
    if (token) {
      return (
        <ErrorBoundary>
          <Suspense fallback={renderLoader()}>
            {children}
          </Suspense>
          {faviconUrl && <Favicon url={faviconUrl} />}
        </ErrorBoundary>
      );
    }else {
      return (<MultiLogin />);
    }

  };

  export default App;
